import { useState } from 'react';

import { useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMutationDeleteRole } from 'api/mutations/deleteRole.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Settings/Components/RolesManagement/components/rolesManagement.module.scss';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';

export const RowOptionsCell = ({ row }) => {
    const { name, id } = row.original;
    const [show, setShow] = useState<boolean>(false);
    const history = useHistory();
    const queryClient = useQueryClient();
    const { pathname } = useLocation();
    const mutation = useMutationDeleteRole();
    const { handleSnackBar } = useCustomSnackBar();

    const handleEdit = () => {
        history.push(`${pathname}/${settingsConfig.roleManagementEditRole.link}/${id}`);
    };

    const handleDelete = () => {
        mutation.mutate(name, {
            onSuccess: () => {
                handleSnackBar('Successfully deleted!', 'success');
            },
            onError: (error) => {
                DEFAULT_ERROR({ error, handleError: handleSnackBar });
            },
            onSettled: () => {
                queryClient.invalidateQueries('getRolesList');
            },
        });

        setShow(false);
    };

    return (
        <div className={classes.actions}>
            <CustomizedRoundIcon onClick={handleEdit}>
                <Icon name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <MuiIcon icon={'delete'} type={'outlined'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete role ${name}?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
